import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: accountID ? `/users?accountID=${accountID}` : '/users'
      }))
  );
}

async function getById(userID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/users/${userID}`
      }))
  );
}

async function create(user) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/users',
        body: JSON.stringify(user)
      }))
  );
}

async function update(user) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/users/${user.userID}`,
        body: JSON.stringify(user)
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(userID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/users/${userID}`
      }))
  );
}

const userService = {
  create,
  getAll,
  getById,
  update,
  delete: Delete
};

export default userService;
